import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';



// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    filepath: null ,
    result_url: null ,
    url : null
};

const slice = createSlice({
    name: 'uploadys',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // START LOADING
        stopLoading(state) {
            state.isLoading = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // UPLOAD FILE
        uploadSuccess(state, action) {
            state.isLoading = false;
            state.filepath = action.payload;
        },

        setPathFile(state , action){
            state.filepath = action.payload;
        },

        setPathFiles(state , action){
            if(state.filepath === null)state.filepath = [];
            state.filepath = [...state.filepath , action.payload];
        },

        setResultUrl(state , action){
            state.result_url = action.payload;
        } ,

        setUrl(state , action){
            state.url = action.payload;
        }
        ,
        // ==== array =====
        setArrResultUrl(state , action){
            if(state.result_url === null)state.result_url = [];
            state.result_url =[...state.result_url , action.payload];
        } ,

        setArrUrl(state , action){
            if(state.url === null)state.url = [];
            state.url =[...state.url , action.payload];
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {actions} = slice;

// Возвращает расширение файла в нижнем регистре без точки: "pdf", "png"
function getFileExtension(file) {
  // по имени
  if (file?.name && file.name.includes(".")) {
    const ext = file.name.split(".").pop().toLowerCase();
    if (ext) return ext;
  }
  // по MIME
  const mime = (file?.type || "").toLowerCase();
  const map = {
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "video/mp4": "mp4",
    "audio/mpeg": "mp3",
    "text/plain": "txt",
    "text/csv": "csv",
  };
  if (map[mime]) return map[mime];

  const parts = mime.split("/");
  if (parts.length === 2 && parts[1]) return parts[1];

  return "";
}

// ----------------------------------------------------------------------

export function uploadFile() {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/api/products');
            dispatch(slice.actions.getUploadUrl(response.data.products));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
// ----------------------
export function clearUploadValue(){
    return async (dispatch) => {
        dispatch(slice.actions.setPathFile(null));
        dispatch(slice.actions.setResultUrl(null));
    };
}
// ----------------------------------------------------------------------

const uploadArrayToYa = async(data , fimages) => {

    let arRes = {error: false , result: false};
    let resImg = null;
    const formFields = data.fields;
    const resultUrl = data.result_url;
    const {url} = data;
    const bodyForm = new FormData();
    const keys = Object.keys(formFields);
    keys.forEach((key, index) => {
        if(key === 'key') resImg = formFields[key]; // slice.actions.setPathFile(formFields[key]);
        // console.log(`REDUCER ${key} : ${formFields[key]}`);
        bodyForm.append(key , formFields[key]);
    });
    bodyForm.append('file' , fimages);
    const resp = await axios.post(data.url, bodyForm, {headers: {"Content-Type": "multipart/form-data"}})
        .then((axiosresp) => {
            console.log(`axios ${fimages} >>>>` , axiosresp);
            // console.log("REDUCER axiosresp" , axiosresp.status);
            if(axiosresp.status === 204){
                console.log("REDUCER IMG LOAD" , resImg );
                // dispatch(slice.actions.uploadSuccess(resImg));
                // dispatch(slice.actions.setResultUrl(resultUrl));
                // dispatch(slice.actions.setUrl(url)); // домен стораджа
                const resact = {
                    uploadSuccess:resImg ,
                    setResultUrl: resultUrl ,
                    setUrl: url
                }
                arRes = {...arRes , result: resact}
            }else{
                arRes = {...arRes , error: axiosresp.status }
            }

        })
        .catch((error) => {
            console.error(error);
            arRes = {...arRes , error }
            // dispatch(slice.actions.hasError(error));
        });

        return arRes;
}

// opts: { extension?: string, autoDetect?: boolean, enforceUniform?: boolean }
export function getUploadUrl(fimages, shopid = '', opts = {}) {
  // чтобы не ломать старые вызовы, поддерживаем старый контракт:
  // если opts не передан — работаем как прежде (без extension)
  // eslint-disable-next-line no-nested-ternary
  const files = Array.isArray(fimages) ? fimages : (fimages ? [fimages] : []);

  // --- вычисляем расширение при необходимости ---
  let finalExt = '';

  if (opts.extension) {
    finalExt = String(opts.extension).toLowerCase().replace(/^\./, '');
  } else if (opts.autoDetect) {
    const exts = files.map(getFileExtension).filter(Boolean);
    if (files.length > 1) {
      // проверяем одинаковость
      const uniq = Array.from(new Set(exts));
      if (uniq.length > 1) {
        // если строгость включена — ошибка и выходим
        if (opts.enforceUniform !== false) {
          return async (dispatch) => {
            dispatch(slice.actions.hasError(new Error('Файлы должны быть одного типа (расширения).')));
            dispatch(slice.actions.stopLoading());
          };
        }
          // мягкий вариант: берём расширение первого файла
          finalExt = exts[0] || '';

      } else {
        finalExt = uniq[0] || '';
      }
    } else {
      finalExt = exts[0] || '';
    }
  }

  // query-параметры
  const hasCount = files.length > 1;
  const str_count = hasCount ? `?count=${files.length}` : '';
  const str_ext = finalExt ? `${hasCount ? '&' : '?'}extension=${encodeURIComponent(finalExt)}` : '';
  const strShopId = typeof shopid === 'string' ? shopid : '';

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const url = `/get_upload_url/${strShopId}${str_count}${str_ext}`;
      const response = await axios.get(url);
      const mult = Array.isArray(response.data);

      if (mult) {
        response.data.forEach((item, index) => {
          uploadArrayToYa(item, files[index]).then(itemRes => {
            if (itemRes.error) {
              dispatch(slice.actions.hasError(itemRes.error));
            } else {
              dispatch(slice.actions.setPathFiles(itemRes.result.uploadSuccess));
              dispatch(slice.actions.setArrResultUrl(itemRes.result.setResultUrl));
              dispatch(slice.actions.setArrUrl(itemRes.result.setUrl));
            }
          });
        });
        dispatch(slice.actions.stopLoading());
      } else {
        uploadArrayToYa(response.data, files[0]).then(res => {
          if (res.error) {
            dispatch(slice.actions.hasError(res.error));
          } else {
            dispatch(slice.actions.uploadSuccess(res.result.uploadSuccess));
            dispatch(slice.actions.setResultUrl(res.result.setResultUrl));
            dispatch(slice.actions.setUrl(res.result.setUrl));
          }
        });
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// export function getUploadUrl(fimages , shopid = '') {
//
//     const str_count = fimages?.length > 1 ? `?count=${fimages.length}`  : '';
//     const strShopId = typeof shopid === 'string' ? shopid : ''
//  // console.log( `/get_upload_url/${strShopId}${str_count}`)
//     return async (dispatch) => {
//         dispatch(slice.actions.startLoading());
//         try {
//             // let resImg = null;
//             const response = await axios.get(`/get_upload_url/${strShopId}${str_count}`);
//             // console.log("UPLOAD RESPONSE YA :::" , Array.isArray(response.data));
//             // console.log("response YA" , response);
//             const mult = Array.isArray(response.data);
//
//             // let arResult = {};
//             if(mult){
//                 // response.data.map(item => {})
//                 // uploadArrayToYa(response.data);
//
//                 response.data.forEach((item, index) => {
//                     // console.log("forEach item" , item);
//                     // console.log("fimages[index]" , fimages[index]);
//                     uploadArrayToYa(item , fimages[index]).then(itemRes => {
//                         console.log("itemRes" , itemRes);
//                         if(itemRes.error){
//                             dispatch(slice.actions.hasError(itemRes.error));
//                         }else if(!itemRes.error){
//                             console.log("::::::: >>>>" , itemRes);
//                             dispatch(slice.actions.setPathFiles(itemRes.result.uploadSuccess));
//                             dispatch(slice.actions.setArrResultUrl(itemRes.result.setResultUrl));
//                             dispatch(slice.actions.setArrUrl(itemRes.result.setUrl)); // домен стораджа
//                         }
//                     })
//                 })
//                 dispatch(slice.actions.stopLoading());
//
//             }else{
//                 uploadArrayToYa(response.data , fimages[0]).then(res => {
//                     if(res.error){
//                         dispatch(slice.actions.hasError(res.error));
//                     }else if(!res.error){
//                         dispatch(slice.actions.uploadSuccess(res.result.uploadSuccess));
//                         dispatch(slice.actions.setResultUrl(res.result.setResultUrl));
//                         dispatch(slice.actions.setUrl(res.result.setUrl)); // домен стораджа
//                     }
//                 });
//
//             }
//
//             // const formFields = response.data.fields;
//             // const resultUrl = response.data.result_url;
//             // const url = response.data.url;
//             // const bodyForm = new FormData();
//             // const keys = Object.keys(formFields);
//             // keys.forEach((key, index) => {
//             //     if(key === 'key') resImg = formFields[key]; // slice.actions.setPathFile(formFields[key]);
//             //     // console.log(`REDUCER ${key} : ${formFields[key]}`);
//             //     bodyForm.append(key , formFields[key]);
//             // });
//             //
//             // console.log("FIMages" , fimages);
//             //
//             // bodyForm.append('file' , fimages);
//             // const resp = await axios.post(response.data.url, bodyForm, {headers: {"Content-Type": "multipart/form-data"}})
//             //     .then((axiosresp) => {
//             //         console.log("===>>>" , axiosresp);
//             //         // console.log("REDUCER axiosresp" , axiosresp.status);
//             //         if(axiosresp.status === 204){
//             //             console.log("REDUCER IMG LOAD" , resImg );
//             //             dispatch(slice.actions.uploadSuccess(resImg));
//             //             dispatch(slice.actions.setResultUrl(resultUrl));
//             //             dispatch(slice.actions.setUrl(url)); // домен стораджа
//             //         }
//             //     })
//             //     .catch((error) => {
//             //         console.error(error);
//             //         dispatch(slice.actions.hasError(error));
//             //     });
//
//             // dispatch(slice.actions.getUploadUrl(response.data));
//
//         } catch (error) {
//             dispatch(slice.actions.hasError(error));
//         }
//     }
// }


// const getDataUploadForm = async (values , loading) => {
//     console.log(`3 - ${loading.current}`);
//
//     try {
//         // await new Promise((resolve) => setTimeout(resolve, 500));
//         loading.current = true;
//         let resImg = null;
//         const response = await axios.get('/get_upload_url');
//         console.log("IMAGES" , values);
//
//         if(values){
//             const formFields = response.data.fields;
//             const bodyForm = new FormData();
//             const keys = Object.keys(formFields);
//             keys.forEach((key, index) => {
//                 if(key === 'key')resImg = formFields[key];
//                 console.log(`${key} : ${formFields[key]}`);
//                 bodyForm.append(key , formFields[key]);
//             });
//
//             bodyForm.append('file' , values);
//             const resp = await axios.post(response.data.url, bodyForm, {headers: {"Content-Type": "multipart/form-data"}})
//                 .then((axiosresp) => {
//                     console.log("axiosresp" , axiosresp.status);
//                     if(axiosresp.status === 204){
//                         console.log("IMG LOAD" );
//
//                         loading.current = false;
//                         console.log(`4 - ${loading.current}`);
//                     }
//                 })
//                 .catch((error) => {
//                     console.error(error);
//                 });
//         }
//     } catch (error) {
//         console.error(error);
//     }
//
// }
